import { connect } from 'react-redux';
import StartSimulatedTestScreen from './screen';
import {
  back_from_simulated_test,
  submit_simulated_test_scores,
  submit_challenge_request,
  submit_challenge_complete_results,
  gotoSimulatedTest,
} from '../../../../redux/actions/SimulatedTestActions';
// import { dashboardDetailsFetch } from "../TabScreens/Dashboard/Action";
import {
  startLoading,
  stopLoading,
} from '../../../../redux/actions/CommonActions';
import {
  updateChallengeStatus,
  save_accepted_challenge_data,
} from '../../../../redux/actions';
import {
  submit_unlocked_achievement,
  achievement_unlocked,
} from '../../../../redux/actions/AchievementActions';

const mapStateToProps = (state) => {
  return {
    state,
    loading: state.LoadingReducer.isLoading,
    sessionToken: state.CommonReducer.sessionToken,
    userId: state.CommonReducer.userId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    back_from_simulated_test: () => dispatch(back_from_simulated_test()),
    updateChallengeStatus: (value) => dispatch(updateChallengeStatus(value)),
    save_accepted_challenge_data: (params) =>
      dispatch(save_accepted_challenge_data(params)),

    submit_simulated_test_scores: (
      simulated_test_score_body,
      dashboardFetch,
      success,
      callback,
    ) =>
      dispatch(
        submit_simulated_test_scores(
          simulated_test_score_body,
          dashboardFetch,
          success,
          callback,
        ),
      ),

    // dashboardDetailsFetch: (params) => dispatch(dashboardDetailsFetch(params)),

    startLoading: () => dispatch(startLoading()),
    stopLoading: () => dispatch(stopLoading()),

    submit_challenge_request: (params, callback) =>
      dispatch(submit_challenge_request(params, callback)),

    submit_challenge_complete_results: (params, callback) =>
      dispatch(submit_challenge_complete_results(params, callback)),

    gotoSimulatedTest: (questionBody, callback) =>
      dispatch(gotoSimulatedTest(questionBody, callback)),
    submit_unlocked_achievement: (submit_data) =>
      dispatch(submit_unlocked_achievement(submit_data)),
    achievement_unlocked: (achievement_key, value) =>
      dispatch(achievement_unlocked(achievement_key, value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StartSimulatedTestScreen);
